import { configureStore } from "@reduxjs/toolkit";
import { useDispatch, useSelector, TypedUseSelectorHook } from "react-redux";
import AttendanceReducer from "./slices/attendance";
import EmployeeReducer from "./slices/employee";
import UserReducer from "./slices/user";
import AuthReducer from "./slices/auth";
import ShiftReducer from "./slices/shift";
import DeviceReducer from "./slices/device";
import DepartmentReducer from "./slices/department";
import OrganisationReducer from "./slices/organisation";
import LevelReducer from "./slices/level";
import ScheduleReducer from "./slices/schedule";
import BranchReducer from "./slices/branch";
import JobReducer from "./slices/job";
import PersonReducer from "./slices/person";
import ContactReducer from "./slices/contact";
import BenefitReducer from "./slices/benefit";
import ErrorReducer from "./slices/error";
import Leave from "./slices/leave";
import Overtime from "./slices/overtime";
import Profile from "./slices/profileUpdate";

const store = configureStore({
  reducer: {
    Attendance: AttendanceReducer,
    Employee: EmployeeReducer,
    User: UserReducer,
    Auth: AuthReducer,
    Shift: ShiftReducer,
    Device: DeviceReducer,
    Department: DepartmentReducer,
    Organisation: OrganisationReducer,
    Level: LevelReducer,
    Schedule: ScheduleReducer,
    Branch: BranchReducer,
    Job: JobReducer,
    Person: PersonReducer,
    Contact: ContactReducer,
    Benefit: BenefitReducer,
    Error: ErrorReducer,
    Leave: Leave,
    Overtime: Overtime,
    Profile: Profile
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

//Writing these here to prevent defining the types in every file
export const useAppDispatch = () => useDispatch<AppDispatch>(); //This is used to perform action
export const useTypedSelector: TypedUseSelectorHook<RootState> = useSelector;
// Used to get the data from the store in the component

export default store;
